import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from 'components/search/Input';
import TypeaheadResults from 'components/search/TypeaheadResults';
import styles from './hero.module.scss';

const Hero = ({tags}) => (
  <section className={styles.Hero}>
    <div className={styles.Hero__content}>
      <p className={styles.Hero__eyebrow}>TeamGantt Support</p>
      <h1 className={styles.Hero__heading}>How can we help?</h1>
      <p className={styles.Hero__summary}>
        Search the help docs or browse by topic to get answers fast.
      </p>
      <div className={styles.Hero__search}>
        <SearchInput>
          {({query, typeaheadResults}) => (
            <TypeaheadResults query={query} results={typeaheadResults} />
          )}
        </SearchInput>
      </div>
      {tags.length > 0 && (
        <div className={styles.Tags}>
          <span className={styles.Tags__label}>Popular</span>
          <ul className={styles.Tags__list}>
            {tags.map(({title, href}) => (
              <li key={title}>
                <a className={styles.Tags__tag} href={href}>
                  {title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </section>
);

Hero.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
};

Hero.defaultProps = {
  tags: [],
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/index.js